import { render, staticRenderFns } from "./SocialAuthentication.vue?vue&type=template&id=f3c26168&"
import script from "./SocialAuthentication.vue?vue&type=script&lang=ts&"
export * from "./SocialAuthentication.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports